import { ODSColumn } from '@telekom-ods/react-ui-kit';
import { Link } from 'react-router';
import TDIConnectLogoBlack from 'src/assets/images/tdi_connect_logo_black.svg?url';
import TDIConnectLogoWhite from 'src/assets/images/tdi_connect_logo_white.svg?url';
import TelecomLogoT from 'src/assets/images/Telecom-logo-T.svg?url';
import type { Theme } from 'src/types';

interface SideNavigationHeaderProps {
  theme: Theme;
}

const SideNavigationHeader = ({ theme }: SideNavigationHeaderProps) => {
  const logo: string = theme === 'light' ? TDIConnectLogoBlack : TDIConnectLogoWhite;

  return (
    <ODSColumn
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        overflow: 'hidden',
        height: 'fit-content',
      }}
    >
      <Link
        to='/'
        style={{
          position: 'relative',
          zIndex: 1000,
          pointerEvents: 'auto',
          cursor: 'pointer',
        }}
      >
        <img
          style={{
            scale: 1.2,
            display: 'block',
            width: 'fit-content',
            height: '64px',
          }}
          src={TelecomLogoT}
          alt='telecom logo T'
        />
      </Link>
      <img
        className='side-navigation-header-logo'
        src={logo}
        alt='TDI Connect Logo'
      />
    </ODSColumn>
  );
};

export default SideNavigationHeader;
